<template>
  <div class="column" :class="layoutClasses">
    <component v-if="item.component"
      class="grid-box"
      :is="item.component"
      :label="item.label"
      :value="item.value"
      v-bind="item.value">
      {{ item.title_key }}
    </component>
    <text-cell-component
      v-else
      :label="item.label"
      :value="getDisplayValue(item.value)">
    </text-cell-component>
  </div>
</template>
<script>
  import TextCellComponent from '@/components/layout/grid/TextCellComponent.vue'
  import StatusCellComponent from '@/components/layout/grid/StatusCellComponent.vue'
  import DocumentsComponent from '@/components/layout/utility/DocumentsComponent'
  import DocumentsTableComponent from '@/components/layout/utility/DocumentsTableComponent'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent'
  import FormFieldComponent from '@/components/form/field/FormFieldComponent'
  import FilesComponent from '@/components/layout/utility/FilesComponent'
  import LinkGridComponent from '@/components/layout/grid/LinkGridComponent'

  export default {
    name: 'cell-component',
    components: {
      StatusCellComponent,
      DocumentsComponent,
      DocumentsTableComponent,
      TextCellComponent,
      SubmitBtnComponent,
      FormFieldComponent,
      FilesComponent,
      LinkGridComponent
    },
    props: {
      item: {
        type: Object,
        required: true,
        validator: (item) => {
          return item.hasOwnProperty('item_key')
        }
      },
      layoutClasses: {
        type: String,
        default: 'is-6-mobile is-4-tablet is-3-desktop'
      }
    },
    methods: {
      getDisplayValue (value) {
        if (!!value && value.constructor === Array) {
          return value.join(', ')
        }
        return value
      }
    }
  }
</script>
<style lang="sass" scoped>
  .is-bold
    font-weight: 700
</style>
